/** @format */

const GENERAL_BLOCK = [
  'scFaName',
  'scEnName',
  'scProvider',
  'description',
  'scUrl',
  'scHttpResponse',
  'scClientId',
  'scHttpVerb',
  'serviceSet',
];
const CALCULATION_BLOCK = [
  'scGuildCode',
  'scPriceCalculationType',
  'price',
  'scPriceHeader',
  'scPriceInquiryUrl',
];
const BODY_BLOCK = ['scInputParams'];
const HEADER_BLOCK = ['scHeaderParams'];
const BENEFICIARY_BLOCK = ['scStakeholderList'];

const fieldsBlock = {
  general: GENERAL_BLOCK,
  body: BODY_BLOCK,
  header: HEADER_BLOCK,
  calculation: CALCULATION_BLOCK,
  beneficiary: BENEFICIARY_BLOCK,
};

export default fieldsBlock;
